import React, { useEffect, useMemo } from 'react';
import { Flex } from 'antd';
import { Outlet } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import styled from 'styled-components';

import { MassBroadcastsTable } from '../components/MassBroadcastsTable';
import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import {
    CommonFiltersProps,
    CommonTableProps,
} from '../../../interfaces/common.interface';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { COMMON_FILTERS, FETCH_DELAY } from '../../../utils/common';
import { TableTitle } from '../../../views/Common/TableTitle';
import {
    BroadcastType,
    CreateOrEditButton,
} from '../../../views/Broadcasts/CreateOrEditButton';
import { BroadcastControls } from '../../../views/Broadcasts/BroadcastControls';
import { BroadcastProps } from '../service/broadcasts.interface';
import { useAppSelector } from '../../../../../store';
import { useLazyReadBroadcastsQuery } from '../service/broadcasts.api';

dayjs.extend(utc);
dayjs.extend(timezone);
export const MassBroadcastsContainer = () => {
    const {
        updateFilters,
        filters,
        get,
        source,
        loading,
        getColumnSearchProps,
    } = useFilters<CommonFiltersProps, BroadcastProps>(
        useLazyReadBroadcastsQuery,
        COMMON_FILTERS
    );

    const current = useAppSelector(selectShopCurrent);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (current.id) {
                const payload = {
                    ...filters,
                    type: [1],
                };

                get({ filters: payload, id: current.id }, true);
            }
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get, current]);

    const tableProps = useMemo<
        CommonTableProps<BroadcastProps, CommonFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumnSearchProps,
        }),
        [loading, source, filters, updateFilters, getColumnSearchProps]
    );

    return (
        <Flex gap={24} vertical>
            <TableTitle title={'Массовые рассылки'} />

            <StyledActions>
                <CreateOrEditButton type={BroadcastType.MASS} />
            </StyledActions>

            <BroadcastControls
                isLoading={loading}
                updateFilters={updateFilters}
                filters={filters}
            />

            <MassBroadcastsTable {...tableProps} />

            <Outlet />
        </Flex>
    );
};

const StyledActions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    z-index: 10;
`;
